import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function PrivateRoute({ children, requiredRoles, fallbackToPublicPreview }) {
    const { user, loading } = useAuth();
    const { courseId } = useParams();

    if (loading) return <div>Carregando...</div>;

    // ==========================
    //  NÃO LOGADO?
    // ==========================
    if (!user) {

        // se permitido cair no preview público
        if (fallbackToPublicPreview && courseId) {
            return <Navigate to={`/curso-publico/${courseId}`} replace />;
        }

        return <Navigate to="/login" replace />;
    }

    // ==========================
    //  ROLE NÃO PERMITIDO?
    // ==========================
    if (requiredRoles && !requiredRoles.includes(user.role)) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}
